export const MOBILE_APP_BAR = {
  height: 56,
  tabsHeight: 32,
}
